module.exports = __webpack_public_path__ + "static/img/Tevita-Pangai-Jr.a93d55c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Tevita-Pangai-Jr.jpg
// module id = 7L3M
// module chunks = 0